"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAriaHiddenOnSiblings = exports.AriaHiddenManager = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
/**
 * A class to manage aria-hidden attributes on sibling elements.
 * It stores references to elements that have had aria-hidden added,
 * allowing them to be removed later without needing to search the DOM again.
 */
class AriaHiddenManager {
  constructor() {
    (0, _defineProperty2.default)(this, "hiddenElements", void 0);
    this.hiddenElements = new Set();
  }

  /**
   * Add aria-hidden attribute to siblings of the wrapper element
   * @param wrapper The element whose siblings should have aria-hidden added
   */
  addAriaHiddenOnSiblings(wrapper) {
    if (!wrapper) return;
    const parent = wrapper.parentElement;
    if (!parent) return;
    Array.from(parent.children).filter(el => el.tagName !== 'SCRIPT' && el !== wrapper).forEach(el => {
      const htmlEl = el;
      if (!htmlEl.hasAttribute('aria-hidden')) {
        htmlEl.setAttribute('aria-hidden', 'true');
        htmlEl.setAttribute('data-stencil-aria-hidden-added', 'true');
        this.hiddenElements.add(htmlEl);
      }
    });
  }

  /**
   * Remove aria-hidden attribute from all elements that were previously hidden
   */
  removeAriaHiddenOnSiblings() {
    this.hiddenElements.forEach(el => {
      el.removeAttribute('aria-hidden');
      el.removeAttribute('data-stencil-aria-hidden-added');
    });
    this.hiddenElements.clear();
  }
}

/**
 * React hook that creates an AriaHiddenManager instance and returns its methods.
 * The returned methods are memoized to prevent unnecessary rerenders.
 *
 * @returns An object containing addAriaHiddenOnSiblings and removeAriaHiddenOnSiblings methods
 */
exports.AriaHiddenManager = AriaHiddenManager;
const useAriaHiddenOnSiblings = () => {
  const managerRef = (0, _react.useRef)(new AriaHiddenManager());
  const addAriaHiddenOnSiblings = (0, _react.useCallback)(wrapper => {
    managerRef.current.addAriaHiddenOnSiblings(wrapper);
  }, []);
  const removeAriaHiddenOnSiblings = (0, _react.useCallback)(() => {
    managerRef.current.removeAriaHiddenOnSiblings();
  }, []);
  return {
    addAriaHiddenOnSiblings,
    removeAriaHiddenOnSiblings
  };
};
exports.useAriaHiddenOnSiblings = useAriaHiddenOnSiblings;